import { Inventory as InventoryIcon } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, Chip, Stack, Typography } from '@mui/material';
import type { Asset } from '../types';

interface AssetCardProps {
  asset: Asset;
  onClick?: () => void;
}

const statusColors: Record<string, 'success' | 'warning' | 'error'> = {
  active: 'success',
  maintenance: 'warning',
  retired: 'error',
};

export function AssetCard({ asset, onClick }: AssetCardProps) {
  return (
    <Card>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
            <Box
              sx={{
                p: 1,
                borderRadius: 1,
                bgcolor: 'primary.light',
                color: 'primary.contrastText',
                mr: 2,
              }}
            >
              <InventoryIcon />
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" component="div" gutterBottom>
                {asset.serial_number || asset.tag_id}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {asset.type || 'No type specified'}
              </Typography>
            </Box>
          </Box>
          <Stack direction="row" spacing={1}>
            <Chip
              label={asset.status}
              size="small"
              color={statusColors[asset.status] || 'default'}
            />
            {asset.customer && (
              <Chip label={asset.customer.name} size="small" variant="outlined" />
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
